import type { SidePanel } from '../types';

export const ChangeEmail: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./EmailPanel.vue')),
};
